<template lang="html">
    <div class="detail">
        <!-- 顶部导航 -->
        <zf-header v-if="$route.query.home || configData.page_detail.top.show || isGoogleSource || isPromotion" :title="detailData.title"
                   :shareBtn="configData.page_detail.top.show_share" :homeBtn="true" @share="share"></zf-header>
        <!-- 主体内容 -->
        <div class="container" v-if="loaded === 'success'" :class="{'margin-top': configData.page_detail.top.show}">
            <!-- 轮播图 -->
            <zf-swiper :swiperData="detailData.images" @touch="swiperTouch"></zf-swiper>
            <!-- 商品简介 -->
            <zf-brief :detailData="detailData" :lang="lang" :config="configData.page_detail.detail"></zf-brief>
            <!-- 订购按钮 -->
            <div v-if="configData.page_detail.detail.show_buy_button" class="buy-now" @click="goPay('home_middle')">
                {{lang.buy_now}}
            </div>
            <!-- 商品图片详情 -->
            <zf-title :title="lang.product_detail"></zf-title>
            <zf-info :productData="detailData.content" @imgLoad="imgLoad"></zf-info>
            <!-- 商品供应保障表格 -->
            <zf-supply :mail="configData.email"></zf-supply>
        </div>
        <div v-if="loaded === 'error'" @click="getDetail"
             style="text-align: center; padding-top: 40vh; padding-bottom: calc(60vh - 100px);">
            <img src="../assets/img/detail/error.svg" alt="" style="width: 50px;">
            <br>
            <br>
            product no found
        </div>
        <!-- 底部按钮 -->
        <zf-footer :config="configData.page_detail.foot" :text="lang.buy_now" @pay="goPay('home_bottom')"
                   @search="search" @service="service"></zf-footer>
        <!-- 到达顶部按钮 -->
        <span class="totop" @click="toTop">TOP</span>
    </div>
</template>

<script>
  import {shopDetail, langInfo, getConfig, mallSubmit, errorCatch} from "../api/permission";
  import Header from '../components/common/header.vue';
  import Swiper from '../components/detail/swiper.vue';
  import Supply from '../components/detail/supply.vue';
  import Brief from '../components/detail/brief.vue';
  import Title from '../components/detail/module-title.vue';
  import Info from "../components/detail/product-info.vue";
  import Footer from "../components/detail/footer.vue";
  import store from '@/vuex/store.js';

  export default {
    components: {
      'zf-header': Header,
      "zf-swiper": Swiper,
      'zf-supply': Supply,
      'zf-brief': Brief,
      'zf-footer': Footer,
      'zf-title': Title,
      'zf-info': Info
    },
    data() {
      return {
        // 商品详情
        detailData: {
          images: [],
          content: {
            content_iv: []
          },
          price: '',
          compare_price: '',
        },
        // 配置
        configData: {
          page_detail: {
            detail: {
              show_buy_button: false,
              show_comment: false,
              show_deadline: false,
              show_feature: false,
              show_service: false
            },
            foot: {
              btn_contact: false,
              btn_search_order: false
            },
            top: {
              show: false,
              show_share: false
            }
          }
        },
        // 语言模板
        lang: {},
        // 'success':成功  'error': 失败
        loaded: null,
        isGoogleSource: source === sourceData.googleSource,
        isPromotion: false
      };
    },
    created() {
      store.commit('SET_HARDLOADING', true);
      this.getLang();
      this.getDetail();
      this.getConfig();

      const homeConfig = [
        "qualitygogo.com",
        "golifestoretw.com",
        "17ihome.com",
        "soanclothes.com",
        "americanwsh.com",
        "warmthcorner.com",
        "bluebirderr.com",
        "stylels.com",
        "darkgogo.com",
        "twgolifestore.com",
        "stylishhoing.com",
        "wshnetwork.com",
        "pomeloinn.com",
        "allbuythailand.com",
      ]
      const host = location.host
      const reg = /.*?([a-z0-9--]{1,200}.com)$/
      const regRes = host.match(reg)
      if (regRes) {
        const rootHost = regRes[1];
        if (homeConfig.indexOf(rootHost) > -1) {
          this.isPromotion = true
        }
      }
    },
    methods: {
      /**
       * 获取语言模板
       */
      async getLang() {
        if (sessionStorage.getItem("lang") && JSON.parse(sessionStorage.getItem("lang")).cl === sessionStorage.cl) {
          this.lang = JSON.parse(sessionStorage.getItem("lang"));
        } else {
          const lang = await langInfo();
          this.lang = lang.data.data;
          sessionStorage.lang = JSON.stringify({cl: sessionStorage.cl, ...lang.data.data});
        }
      },
      /**
       * 获取配置信息
       */
      async getConfig() {
        if (sessionStorage.getItem("configData") && JSON.parse(sessionStorage.getItem("configData")).cl === sessionStorage.cl) {
          this.configData = JSON.parse(sessionStorage.getItem("configData"));
        } else {
          const configData = await getConfig();
          if (configData.data && configData.data.data) {
            this.configData = configData.data.data;
            sessionStorage.configData = JSON.stringify({cl: sessionStorage.cl, ...configData.data.data});
          }
        }
      },
      /**
       * 获取详情
       */
      async getDetail() {
        const params = {
          item: this.$route.query.id || '',
          path: this.$route.query.path || '',
        };
        const s_time = Date.now();
        shopDetail(params).then((res) => {
          store.commit('SET_HARDLOADING', false);
          if (res.data && res.data.data) {
            this.loaded = 'success';
            this.detailData = res.data.data;
            // 价格存入cookie当中
            this.setCookie("price",this.detailData.price)
          } else {
            this.loaded = 'error';
            console.log('网络错误或没有相关商品');
            let err = {
              url: res.config.url,
              params,
              request_time: Date.now() - s_time,
              status: res.status || (res.response && res.response.status) || -1,
              message: res.message
            }
            errorCatch(err)
          }
          gtag('set', 'currencyCode', this.detailData.iso_code);
          fbq('track', 'ViewContent', {
            content_ids: [this.detailData.product_hash],
            content_type: 'product',
            value: this.detailData.price,
            currency: this.detailData.iso_code,
          });
          ttq.track('ViewContent', {
            content_ids: [this.detailData.product_hash],
            content_type: 'product',
            value: this.detailData.price,
            currency: this.detailData.iso_code,
          });
          const loadTime = Date.now() - startTime;
          gtag('event', 'ViewContent', {
            event_category: window.location.href,
            event_label: 'home',
            value: loadTime
          });
          mallSubmit({
            // hash: this.detailData.product_hash,
            event_name: 'ViewContent',
            event_label: 'home',
            value: loadTime
          });

          // 发送cartsee埋点数据
          let count = 0;
          let uuid = this.generateUUID()
          this.cartseePost(count,uuid)
        }).catch((e) => {
          store.commit('SET_HARDLOADING', false);
        })
      },
      /**
       * 跳转页面顶部
       */
      toTop() {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      },
      /**
       * 跳转付款页面
       */
      goPay(btnName) {
        if (this.loaded === 'error') {
          this.getDetail();
        } else if (localStorage.source === sourceData.yahooSource) {
           location.pathname = '/pay';
        } else {
          store.commit('SET_HARDLOADING', true);
          this.$router.push({
            path: '/pay',
            query: {
              id: this.$route.query.id,
              path: this.$route.query.path,
            }
          });
        }
        fbq('track', 'AddToCart', {
          content_ids: [this.detailData.product_hash],
          content_type: 'product',
          value: this.detailData.price,
          currency: this.detailData.iso_code,
        });
        ttq.track('AddToCart', {
          content_ids: [this.detailData.product_hash],
          content_type: 'product',
          value: this.detailData.price,
          currency: this.detailData.iso_code,
        });
        gtag('event', 'AddToCart', {
          event_category: window.location.href,
          event_label: btnName,
          value: this.detailData.price
        });
        mallSubmit({
          // hash: this.detailData.product_hash,
          event_name: 'AddToCart',
          event_label: btnName,
          value: this.detailData.price,
          event_currency: this.detailData.iso_code
        });
      },
      /**
       * 分享
       */
      share() {
        console.log('分享')
      },
      /**
       * 订单查询
       */
      search() {
        this.$router.push({
            path: '/search',
            query: {
                id: this.$route.query.id,
                path: this.$route.query.path,
            }
        });
        gtag('event', 'OrderTracking', {
          event_category: window.location.href,
          event_label: 'query',
          value: this.detailData.price
        });
        mallSubmit({
          // hash: this.detailData.product_hash,
          event_name: 'OrderTracking',
          event_label: 'query',
        });
      },
      /**
       * 客服
       */
      service() {
        gtag('event', 'CustomerService', {
          event_category: window.location.href,
          event_label: 'home',
          value: this.detailData.price
        });
        mallSubmit({
          // hash: this.detailData.product_hash,
          event_name: 'CustomerService',
          event_label: 'home',
        });
      },
      /**
       * 触摸轮播图
       */
      swiperTouch() {
        mallSubmit({
          // hash: this.detailData.product_hash,
          event_name: 'SlideTop',
          event_label: 'home_top',
        });
      },
      /**
       * 详情图片加载
       */
      imgLoad(event) {
        mallSubmit({
          // hash: this.detailData.product_hash,
          event_name: 'SlideDetail',
          event_label: 'home_detail_' + event.index,
          event_run: event.timeStamp
        });
      },
      cartseePost(count,uuid){
        if (count < 10) {
          // 条件满足时的处理逻辑
          if (window.cartq){
            count = 10
            window.cartq('track', 'Site/Visit', {
              "pathName": window.location.href, // 当前页面地址 location.href
              "email": "", // 用户的email,在已登录情形下才会有
              "phone": "" // 用户的phone,在已登录情形下才会有
            }, {
              "uid": uuid,//第三方的唯一用户标识, 类似cookie
              "customerId": "" //用户id，在已登录情形下才会有 ，
            })

            window.cartq('track', 'Site/ViewProduct', {
              pathName: window.location.href,//当前页面地址
              "productId": new URLSearchParams(window.location.search).get('id'),   //商品信息
              "productName": sessionStorage.seo_title,//商品信息
              "price": this.getCookie("price"),//商品信息
              "compareAtPrice": "",//商品信息  （选填）
              "email": "",  // 用户的email
              "phone":""   // 用户的phone
            },{
              "uid": uuid,//第三方的唯一用户标识, 类似cookie
              "customerId": ""//用户id，在已登录情形下才会有 ，
            })
          }
          count++;
          setTimeout(() => {
            this.cartseePost(count,uuid)
          }, 2000); // 2秒钟后再次执行循环器
        }
      },
      generateUUID(){
        // 1. 判断cookie是否有唯一uuid：cartsee_uuid
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          if (cookie.startsWith('cartsee_uuid=')) {
            return cookie.substring('cartsee_uuid='.length)
          }
        }

        // 2. 新建uuid存入cookie
        let cartsee_uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = Math.random() * 16 | 0,
              v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        })
        document.cookie = ('cartsee_uuid=' + cartsee_uuid);
        return cartsee_uuid;
      },
      /**
       * 设置cookie
       * @param c_name
       * @param value
       * @param expireDays
       */
      setCookie(c_name, value, expireDays = null){
        const exDate = new Date();
        exDate.setDate(exDate.getDate() + expireDays);
        document.cookie = c_name+ "=" + escape(value) + ((expireDays == null) ? "" : ";expires=" + exDate.toGMTString())
      },
      /**
       * 获取cookie
       * @param cookieName
       * @return {string}
       */
      getCookie(cookieName) {
        const strCookie = document.cookie;
        let arrCookie = strCookie.split("; ");
        for (let i = 0; i < arrCookie.length; i++) {
          let arr = arrCookie[i].split("=");
          if (cookieName === arr[0]) {
            return unescape(arr[1]);
          }
        }
        return "";
      }
    },
  };
</script>
<style scoped>

    .detail {
        margin: 0 auto;
        max-width: 640px;
        min-height: 100%;
        background: #fff;
    }

    .detail .container {
        padding: 0 0 50px;
    }

    .margin-top {
        margin-top: 44px;
    }

    .buy-now {
        margin: 14px 22px;
        padding: 8px 0;
        border: 1px solid #bbb;
        border-radius: 5px;
        color: #fff;
        font-size: 1rem;
        background: #E31A07;
        text-align: center;
        text-decoration: none;
        cursor: pointer;
    }

    .totop {
        z-index: 20;
        text-decoration: none;
        border-radius: 45px;
        width: 45px;
        line-height: 45px;
        right: 15px;
        position: fixed;
        bottom: 60px;
        display: block;
        text-align: center;
        height: 45px;
        border: 1px solid #232323;
        color: #fff;
        background: #000;
        opacity: 0.4;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/views/Detail.vue